export function parsePositiveInt(value, fallback = 1) {
    const parsed = parseInt(value, 10)

    return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback
}

export function getCartQuantityStep(product) {
    const multiplicity = parsePositiveInt(product?.attributes?.cart_multiplicity, 0)

    return multiplicity > 1 ? multiplicity : 1
}

export function getCartQuantityMin(product) {
    return parsePositiveInt(product?.min_volume_to_buy, getCartQuantityStep(product))
}

export function getNextCartQuantity(product, delta) {
    const current = parsePositiveInt(product?.quantity, 0)
    const step = getCartQuantityStep(product)
    const min = getCartQuantityMin(product)
    const next = current + delta * step

    if (delta < 0 && next < min) {
        return min
    }

    const max = parsePositiveInt(product?.attributes?.max_qty, 0)
    if (delta > 0 && max > 0 && next > max) {
        return current
    }

    return next
}
